import styles from "./TabSelection.module.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const TabSelection = ({ tabs }: any): React.ReactElement => {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab: any, index: number) => {
        return (
          <Link
            key={index}
            to={tab.link}
            className={`${styles.tab}`}
            style={
              {
                "--tab-hover-color": tab.bgColor,
              } as React.CSSProperties
            }
          >
            <span className={styles.label}>
              {tab?.content ? tab.content : tab.label}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default TabSelection;
